import { merge, isObject, isString, startCase } from 'lodash-es';

const lang = {};
const cache = {};

Array.prototype.forEach.call(document.querySelectorAll('script[type="text/x-i18n-json"]'), element => {
  try {
    const obj = JSON.parse(element.innerHTML);
    merge(lang, obj);
  } catch (e) {
    throw new Error('Invalid JSON in script tag');
  }
});

export default function (entry, options) {
  // Try to get cached result
  let s = cache[entry] || '';

  // If not cached value
  if (!s) {
    const path = entry.split('.');
    let currLang = lang;

    // Loop through all path values
    path.forEach((key, index) => {
      // Test object
      if (isObject(currLang)) {
        currLang = currLang[key] || null;
      } else {
        currLang = null;
      }

      // Reach final path element
      if (index === path.length - 1) {
        if (isString(currLang)) {
          s = currLang;
        }
      }
    });

    // Save the result
    cache[entry] = s;
  }

  // Handle options
  if (isObject(options)) {
    // Replace `:key` with `replacements[key]`
    if (isObject(options.replacements)) {
      Object.keys(options.replacements).forEach(key => {
        s = s.replace(':' + key, options.replacements[key]);
      });
    }

    // Uppercase first letter
    if (options.startCase) {
      s = startCase(s);
    }
  }

  return s;
};
